<template>
  <!-- Balances -->
  <section v-if="balanceList.length > 0" class="fiat-balances-wrapper">
    <h2>{{ title }}</h2>
    <div class="balances-wrapper ">
      <dl>
        <div
          :key="bal.id"
          v-for="bal in balanceList"
          :class="bal.currency">
          <dt>{{ bal.currency }} {{ bal.crypto_blockchain ? `(${bal.crypto_blockchain})` : '' }}</dt>
          <dd>
            <span>{{ bal.type === 'fiat_money' ? formatFiatPrice(bal.available_balance) : formatCryptoAmount(bal.available_balance, bal.currency) }}</span>
          </dd>
        </div>
      </dl>
    </div>
  </section>
</template>
<script>
export default {
  props: {
    balanceList: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  }
};
</script>
<style lang="scss">
.fiat-balances-wrapper {
  h2 {
    font-size: 20px;
    margin-bottom: 12px;
    color: #505050;
  }

  &>.balances-wrapper {
    margin-top: 12px;

    dl {
      div {
        align-items: center;
        &::before {
          height: 32px;
          width: 32px;
        }
        dt {
          font-weight: normal;
        }
        dd {
          line-height: calc(100% - 16px); // total height - paddings
        }
      }
    }
  }
}
</style>